module.exports = __webpack_public_path__ + "static/media/dashboard.768b7735.svg";